// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchExamples-cls1_GCi","cls2":"ResearchExamples-cls2_dld ResearchExamples-cls1_GCi"};